import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";

import { List, Users, Grid3X3 } from "lucide-react";
import TabsComponent from "@/components/tabs/tabs-component";

import { AddTechnicianSheet } from "./components/add-technician-sheet";
import { WorkspaceToggle } from "@/components/workspace-toggle";

export const Route = createFileRoute(
  "/plant-3/(technician-screens)/technicians",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const location = useLocation();
  const activeTab = location.pathname;

  const tabs = [
    {
      icon: <List className="aero:h-5 aero:w-5" />,
      label: "Technician List",
      direction: "/plant-3/technicians/list",
    },
    {
      icon: <Grid3X3 className="aero:h-5 aero:w-5" />,
      label: "Grouped by Shop",
      direction: "/plant-3/technicians/grouped",
    },
  ];

  return (
    <div className="aero:flex aero:flex-col aero:gap-4 aero:w-full aero:max-w-full aero:px-4 aero:overflow-hidden">
      {/* Page Title */}
      <div className="aero:flex aero:items-center aero:justify-between">
        <div className="aero:flex aero:items-center aero:gap-3">
          <div className="aero:w-10 aero:h-10 aero:rounded-lg aero:bg-brand-primary-50 aero:flex aero:items-center aero:justify-center">
            <Users className="aero:text-brand-primary-500 aero:h-6 aero:w-6" />
          </div>
          <div>
            <h1 className="aero:text-xl aero:md:text-2xl aero:text-foreground aero:font-bold aero:leading-9">
              Technicians
            </h1>
            <p className="aero:text-xs aero:md:text-sm aero:text-neutral-500 aero:leading-5">
              Manage technicians, their assignments, and availability
            </p>
          </div>
        </div>
        <WorkspaceToggle />
      </div>
      {/* Tabs */}
      <TabsComponent
        tabs={tabs}
        activeTab={activeTab}
        addOnsButton={<AddTechnicianSheet />}
      />

      <Outlet />
    </div>
  );
}
